module.exports = __webpack_public_path__ + "static/media/Rectanglemob.7561fa04.svg";